<template>
    <div class="popupManage">
      <el-divider content-position="left">按条件搜索</el-divider>
      <el-row :gutter="20">
        <el-col :span="5" >
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">名称</span>
            <el-input style="width: 70%" v-model="tableConfig.title" placeholder="请输入名称" maxlength="100"></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">状态</span>
            <el-select
              v-model="tableConfig.usageStatus"
              style="width: 70%"
              placeholder="请选择"
            >
              <el-option
                key="1"
                label="未启用"
                value="0"
              >
              </el-option>
              <el-option
                key="0"
                label="启用"
                value="1"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">开始时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">结束时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-divider content-position="left">功能按钮</el-divider>
      <el-row :gutter="20">
        <el-col :span="18" >
          <div class="grid-content bg-purple">
            <el-button type="primary" @click="searchList">查 询</el-button>
            <el-button type="primary" @click="rest">重 置</el-button>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="grid-content">
            <el-button type="primary" @click="openAdd">新 增</el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider content-position="left">popup列表</el-divider><br />
      <el-table style="width: 100%; margin-top: 20px" fit stripe :data="tableData" border>
        <el-table-column sortable prop="title" label="名称" width="300"></el-table-column>
        <!--        <el-table-column sortable prop="hitCount" label="点击量"></el-table-column>-->
        <el-table-column sortable prop="usageStatus" label="状态"></el-table-column>
        <el-table-column sortable prop="startTime" label="开始日期"></el-table-column>
        <el-table-column sortable prop="endTime" label="结束日期"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="deletePopup(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 编辑 -->
      <el-dialog
        :title=" popupTitle + 'Popup'"
        :visible.sync="dialogVisible"
        width="50%"
        center
        :before-close="handleClose">
        <el-form :model="ruleForm" label-width="120px">
          <el-form-item label="名称:" prop="title">
            <el-input v-model="ruleForm.title" placeholder="请输入名称" maxlength="100"></el-input>
          </el-form-item>
  
          <el-form-item label="开始日期:" prop="startTime">
            <el-date-picker
              v-model="ruleForm.startTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
  
          <el-form-item label="结束日期:" prop="endTime">
            <el-date-picker
              v-model="ruleForm.endTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
  
          <el-form-item label="每天开始时间:" prop="everydayStartTime">
            <el-time-picker
              v-model="ruleForm.everydayStartTime"
              value-format="HH:mm:ss"
              placeholder="00:00:00">
            </el-time-picker>
          </el-form-item>
  
          <el-form-item label="每天次数:" prop="showCount">
            <el-input-number v-model="ruleForm.showCount" :min="1" label=""></el-input-number>
          </el-form-item>
  
          <el-form-item label="启用:" prop="usageStatus">
            <el-switch
              v-model="ruleForm.usageStatus"
              active-color="#67C23A"
            >
            </el-switch>
          </el-form-item>
  
          <anyImageUpload
            label="图片"
            labelWidth="120"
            v-model="ruleForm.imageUrl"
            :type="2"
          />
  
  <!--        <el-form-item label="targetUrl:" prop="targetUrl">-->
  <!--          <el-input v-model="ruleForm.targetUrl" placeholder="请输入targetUrl"></el-input>-->
  <!--        </el-form-item>-->
  
  <!--        <el-form-item label="targetId:" prop="targetId">-->
  <!--          <el-input v-model="ruleForm.targetId" placeholder="请输入targetId"></el-input>-->
  <!--        </el-form-item>-->
  
          <el-form-item label="所属系统:" prop="type">
            <el-select
              v-model="ruleForm.type"
              style="width: 100%"
              clearable
              placeholder="请选择所属系统"
            >
              <el-option
                v-for="(item, index) in systemTypeList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
  
  
        </el-form>
  
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPopup">保 存</el-button>
        <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
      </span>
      </el-dialog>
  
      <footer>
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-count="tableConfig.size"
          :page-sizes="[10, 20, 30, 50,100]"
          :page-size="10"
          :current-page="tableConfig.index"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </template>
  <script>
  import _ from 'lodash'
  import anyImageUpload from "@/components/anyImageUpload";
  
  export default {
    name: "PopupManage",
    data() {
      return {
        popupTitle: '',
        imageUrl: "", //大图
        initRuleForm: {
          endTime: '',
          everydayStartTime: '',
          id: 0,
          imageUrl: '',
          showCount: '',
          startTime: '',
          targetId: '',
          targetUrl: '',
          title: '',
          type: '',
          usageStatus: false
        },
        ruleForm: {
        },
        typeList: [
        ],
        loading: false,
        dialogVisible: false, // 弹框显示
        total: 0, // 总数量
        tableConfig: {
          size: 10, // 每页条数
          index: 1, // 当前页码
          title: '',
          startTime: '',
          endTime: ''
        },
        tableData: [],
        formLabelWidth: '120px',
        systemTypeList: []
      };
    },
    components: {
      anyImageUpload,
    },
    mounted() {
      this.searchList()
      this.getTypeList()
    },
    methods: {
      openAdd () {
        this.dialogVisible = true
        this.popupTitle = '新增'
        this.ruleForm = _.cloneDeep(this.initRuleForm)
      },
      openEdit (row) {
        this.dialogVisible = true
        this.popupTitle = '编辑'
        this.getData(row.id)
      },
      searchList(){
        this.tableConfig.index = 1;
        this.getList();
      },
      async getList() {
        let res = await this.$api.public_api.listPopup(this.tableConfig);
        if (res) {
          this.tableData = res.listPopup.list || [];
          this.total = res.listPopup.total;
        }
      },
      async getTypeList() {
        let res = await this.$api.public_api.getTypeList()
        if (res) {
          this.systemTypeList = res.resultInfos || [];
        }
      },
      async getData(id) {
        let res = await this.$api.public_api.getPopup(id);
        if (res) {
          this.ruleForm = res.getPopup
          this.ruleForm.usageStatus = this.ruleForm.usageStatus ? true : false
        }
      },
      async submitPopup(){
        let submitUrl
        if (this.ruleForm.id) {
          submitUrl = '/popup/updPopup'
        } else {
          submitUrl = '/popup/insertPopup'
        }
        /*if (this.ruleForm.everydayStartTime) {
          this.ruleForm.everydayStartTime = _.toString(new Date(this.ruleForm.everydayStartTime)).split(' ')[4];
        }*/
        let submitData = _.cloneDeep(this.ruleForm);
        _.assignIn(submitData, {usageStatus: submitData.usageStatus ? 1 : 0})
        let res = await this.$axios.post(this.$api.public_api.base+submitUrl, submitData);
        if (res) {
          this.$message.success('操作成功！')
          this.dialogVisible = false;
          await this.searchList();
        }
      },
  
      async deletePopup(id) {
        await this.$confirm('确定删除该popup吗?', '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.public_api.delPopup(id).
          then((response) => {
            if (response) {
              this.searchList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
      },
  
      currentChange(index) {
        // 分页
        this.tableConfig.index = index;
        this.getList();
      },
      sizeChange(size) {
        this.tableConfig.size = size;
        this.getList();
      },
      handleClose(done) {
        this.$confirm("确认关闭？")
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      rest() {
        this.tableConfig.title="";
        this.tableConfig.startTime="";
        this.tableConfig.endTime="";
        this.tableConfig.usageStatus="";
      },
  /*    statusFormatter(row){  //状态格式化
        switch (row.status) {
          case 1:
            return "开启"
            break;
          case 0:
            return "禁用"
            break;
          default:
            return "未知"
            break;
        }
      },*/
    }
  };
  </script>
  <style lang="scss" scoped>
  .popupManage{
    padding: 20px 10px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    .label{
      display: inline-block;
      width: 70px;
    }
    footer{
      padding-top: 20px;
      text-align: right;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/interaction/popup1.vue